<template>
<div>
  <h3 class="wph-text-2xl wph-text-accent-dark wph-mb-4">Размеры:</h3>
  <slot name="errors"></slot>
  <multiselect :options="availableSizes" v-model="pickedSizes"
               :multiple="true"
               :hideSelected="true"
               :searchable="false"
               track-by="id"
               label="label"
               placeholder="Добавить размер"
               @select="onSizeAdd"
               @remove="onSizeRemove"
               class="wph-mb-3"
  ></multiselect>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: "SizePicker",
  components: {
    Multiselect,
  },
  props: {
    product: Object,
    sizes: { type: Array, required: true },
    updateProduct: Function,
  },
  created() {
    this.pickedSizes = this.sizes.map((size) => {
      return this.textileSizes[size.data.id]
    })
  },
  data() {
    return {
      pickedSizes: [],
      /**
       * Осуществляется ли обновление элемента корзины из данного компонента
       * следует устанавливать в true перед добавлением размеров из данного компонента
       * и сразу после обновления возвращать в false
       */
      internalProductUpdate: false,
    }
  },
  computed: {
    productGeneralType() {
      return this.product.type.id === 'bags' ? 'bags' : 'textile'
    },
    textileSizes() {
      return this.$store.state.textileSizes[this.productGeneralType]
    },
    // доступные для данной модели размеры в виде списка объектов
    availableSizes() {
      return this.product.model.sizes.map((sizeName) => this.textileSizes[sizeName])
    },
  },
  methods: {
    onSizeAdd(size) {
      const prepSize = {
        data: size,
        number: 0,
      }

      this.internalProductUpdate = true
      this.updateProduct({ sizes: [...this.product.sizes, prepSize] })
      this.internalProductUpdate = false
    },
    onSizeRemove(sizeToRemove) {
      this.internalProductUpdate = true
      this.updateProduct({
        sizes: this.product.sizes.filter((size) => size.data.id !== sizeToRemove.id)
      })
      this.internalProductUpdate = false
    },
  },
}
</script>